import { AGGREGATE_NAMES, CHAT_RESOLVERS } from 'cpool-constants';
import type { SchemaChatResolver_GetMessages } from 'cpool-tables/backend-resolvers';
import { schemaChatResolver_GetMessages } from 'cpool-tables/backend-resolvers';

import { DEFAULT_MESSAGE_PAGE_SIZE } from '~/features/whatsapp/constants';
import { buildQueryString, fetcher } from '~/queryUtils/useQuery';

export const fetchChatMessagesGap = async (
    chatId: string,
    after: number,
    limit = DEFAULT_MESSAGE_PAGE_SIZE,
): Promise<SchemaChatResolver_GetMessages> => {
    const queryUrl = `/query/${AGGREGATE_NAMES.CHAT}/${CHAT_RESOLVERS.getMessages}${buildQueryString({
        after,
        chatId,
        limit,
    })}`;

    return fetcher<typeof schemaChatResolver_GetMessages>({
        meta: { queryUrl, schema: schemaChatResolver_GetMessages },
    });
};
